import { render, staticRenderFns } from "./CustomerMobile.vue?vue&type=template&id=61dd0b3c&scoped=true"
import script from "./CustomerMobile.vue?vue&type=script&lang=js"
export * from "./CustomerMobile.vue?vue&type=script&lang=js"
import style0 from "./CustomerMobile.vue?vue&type=style&index=0&id=61dd0b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dd0b3c",
  null
  
)

export default component.exports